

import React, { useEffect } from 'react';

const LoginPopup = ({ isOpen, onClose, titre, contenu, icon = '📄', accentColor = '#448696' }) => {
  // Bloquer le scroll body quand ouvert
  useEffect(() => {
    if (isOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');

        .hp-popup-overlay {
          position: fixed; inset: 0; z-index: 9999;
          background: rgba(10, 15, 30, 0.72);
          display: flex; align-items: center; justify-content: center;
          padding: 24px;
          animation: hpPopupFadeIn 0.2s ease-out;
        }

        .hp-popup-container {
          width: 100%; max-width: 620px; max-height: 85vh;
          border-radius: 20px; overflow: hidden;
          background: #ffffff;
          box-shadow: 0 40px 80px rgba(0,0,0,0.3), 0 0 0 1px rgba(0,0,0,0.06);
          display: flex; flex-direction: column;
          font-family: 'DM Sans', sans-serif;
          animation: hpPopupSlideUp 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
        }

        .hp-popup-header {
          padding: 22px 26px 20px;
          border-bottom: 1px solid #f0f0f0;
          display: flex; align-items: center; gap: 14px;
          flex-shrink: 0;
          position: relative;
          overflow: hidden;
        }

        .hp-popup-header::before {
          content: '';
          position: absolute; top: 0; left: 0; right: 0; height: 3px;
        }

        .hp-popup-icon {
          width: 44px; height: 44px; border-radius: 12px; flex-shrink: 0;
          display: flex; align-items: center; justify-content: center;
          font-size: 22px;
        }

        .hp-popup-title {
          font-size: 17px; font-weight: 800; color: #0f172a; margin: 0; flex: 1;
          letter-spacing: -0.3px; line-height: 1.2;
          font-family: 'DM Sans', sans-serif;
        }

        .hp-popup-subtitle {
          font-size: 12px; font-weight: 500; color: #94a3b8; margin: 3px 0 0;
          font-family: 'DM Sans', sans-serif;
        }

        .hp-popup-close {
          width: 34px; height: 34px; border-radius: 9px;
          border: 1.5px solid #e2e8f0; background: #f8fafc;
          color: #64748b; cursor: pointer; flex-shrink: 0;
          display: flex; align-items: center; justify-content: center;
          font-size: 16px; line-height: 1;
          transition: all 0.15s ease;
          font-family: 'DM Sans', sans-serif;
        }
        .hp-popup-close:hover {
          background: #fee2e2; border-color: #fca5a5; color: #dc2626;
          transform: scale(1.05);
        }

        .hp-popup-body {
          padding: 24px 26px;
          overflow-y: auto; flex: 1;
          scrollbar-width: thin;
        }
        .hp-popup-body::-webkit-scrollbar { width: 6px; }
        .hp-popup-body::-webkit-scrollbar-track { background: #f1f5f9; border-radius: 99px; }
        .hp-popup-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 99px; }
        .hp-popup-body::-webkit-scrollbar-thumb:hover { background: #94a3b8; }

        .hp-popup-content {
          font-size: 13.5px; color: #334155; line-height: 1.8;
          white-space: pre-line; margin: 0;
          font-family: 'DM Sans', sans-serif; font-weight: 400;
        }

        .hp-popup-footer {
          padding: 16px 26px 20px;
          border-top: 1px solid #f0f0f0;
          display: flex; align-items: center; justify-content: flex-end; gap: 10px;
          flex-shrink: 0; background: #fafafa;
        }

        .hp-popup-btn-close {
          padding: 10px 24px; border-radius: 10px;
          border: none; color: white;
          font-size: 13px; font-weight: 700; cursor: pointer;
          transition: all 0.2s ease;
          font-family: 'DM Sans', sans-serif;
          letter-spacing: 0.1px;
        }
        .hp-popup-btn-close:hover {
          filter: brightness(1.08);
          transform: translateY(-1px);
          box-shadow: 0 6px 16px rgba(0,0,0,0.2);
        }
        .hp-popup-btn-close:active {
          transform: translateY(0);
        }

        .hp-popup-badge {
          font-size: 10px; font-weight: 700; text-transform: uppercase;
          letter-spacing: 0.8px; padding: 4px 10px; border-radius: 99px;
          font-family: 'DM Sans', sans-serif;
        }

        @keyframes hpPopupFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes hpPopupSlideUp {
          from { opacity: 0; transform: translateY(20px) scale(0.97); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }

        @media (max-width: 480px) {
          .hp-popup-overlay { padding: 0; align-items: stretch; }
          
         .hp-popup-container {
            max-width: 100%;
            max-height: 100vh;
            height: 100vh;
            border-radius: 0;
          }

          .hp-popup-header { padding: 16px 18px 14px; gap: 10px; }

          .hp-popup-icon { width: 36px; height: 36px; border-radius: 10px; font-size: 18px; flex-shrink: 0; }

          .hp-popup-title { font-size: 14px; }

          .hp-popup-subtitle { font-size: 11px; }

          .hp-popup-badge { display: none; }

          .hp-popup-close { width: 30px; height: 30px; font-size: 14px; }

          .hp-popup-body { padding: 18px; }

          .hp-popup-content { font-size: 13px; line-height: 1.7; }

          .hp-popup-footer { padding: 12px 18px 16px; }

          .hp-popup-footer span { display: none; }

          .hp-popup-btn-close { padding: 10px 20px; font-size: 13px; width: 100%; }
        }

      `}</style>

      <div className="hp-popup-overlay">
        <div className="hp-popup-container">

          {/* ── Header ── */}
          <div className="hp-popup-header" style={{ background: `linear-gradient(135deg, ${accentColor}08 0%, #ffffff 60%)` }}>
            {/* Barre couleur en haut */}
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: `linear-gradient(90deg, ${accentColor}, ${accentColor}80)` }} />

            <div className="hp-popup-icon" style={{ background: `${accentColor}12`, border: `1.5px solid ${accentColor}20` }}>
              {icon}
            </div>

            <div style={{ flex: 1, minWidth: 0 }}>
              <p className="hp-popup-title">{titre}</p>
              <p className="hp-popup-subtitle">HORAPILOT - DANICED GROUP</p>
            </div>

            {/* Badge */}
            <span className="hp-popup-badge" style={{ background: `${accentColor}12`, color: accentColor, border: `1px solid ${accentColor}25` }}>
              Officiel
            </span>

            <button className="hp-popup-close" onClick={onClose} title="Fermer">
              ✕
            </button>
          </div>

          {/* ── Corps ── */}
          <div className="hp-popup-body">
            {contenu ? (
              <p className="hp-popup-content">{contenu}</p>
            ) : (
              <div style={{ textAlign: 'center', padding: '32px 0', color: '#94a3b8' }}>
                <div style={{ fontSize: 36, marginBottom: 12 }}>⚙️</div>
                <p style={{ fontSize: 14, fontWeight: 600, color: '#64748b', fontFamily: 'DM Sans, sans-serif' }}>
                  Contenu non configuré
                </p>
                <p style={{ fontSize: 12, color: '#94a3b8', marginTop: 4, fontFamily: 'DM Sans, sans-serif' }}>
                  Rendez-vous dans le centre d'administration pour configurer ce contenu.
                </p>
              </div>
            )}
          </div>

          {/* ── Footer ── */}
          <div className="hp-popup-footer">
            <span style={{ fontSize: 11, color: '#94a3b8', fontFamily: 'DM Sans, sans-serif', fontWeight: 500 }}>
              © {new Date().getFullYear()} DANICED GROUP
            </span>
            <button
              className="hp-popup-btn-close"
              onClick={onClose}
              style={{ background: `linear-gradient(135deg, ${accentColor}, ${accentColor}cc)`, boxShadow: `0 4px 12px ${accentColor}35` }}>
              Fermer
            </button>
          </div>

        </div>
      </div>
    </>
  );
};

export default LoginPopup;